import React from 'react';
import { ProductEnhancer } from '../../components/tools/ProductEnhancer';
import { useToolExecution } from '../../hooks/useToolExecution';
import { ToolHeader } from '../../components/ui/ToolHeader';
import { TOOL_COSTS } from '../../constants';

export const EnhancerTool = () => {
  const { checkCredits, deductCredits } = useToolExecution();

  return (
    <div>
      <ToolHeader 
        title="Product Enhancer"
        cost={`${TOOL_COSTS.enhance} credits`}
        description={
          <>
            <p className="font-bold">Transform raw product photos into high-end studio photography.</p>
            <p>1. <strong>Upload Photos:</strong> Upload one or multiple raw images (JPG/PNG).</p>
            <p>2. <strong>Select Product Category:</strong> Choose a product type or create a new category.</p>
            <p>3. <strong>Choose or Create a Style:</strong> Pick a pre-saved style or use the AI Style Generator to describe the desired look.</p>
            <p>4. <strong>Enhance:</strong> The AI processes each image based on your selected style.</p>
          </>
        }
      />
      <ProductEnhancer 
        onCostIncurred={(cost) => deductCredits(cost, 'Product Enhancer')} 
        checkCredits={checkCredits}
      />
    </div>
  );
};
